const Dummy = (props) => {

  
  return (
    <svg
      id="fb7a9eac-f1d7-4841-9a9d-610a99e3400f"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1194 843"
      {...props}
    >
      <defs>
        <style>
          {
            '.e000f16a-d505-4d18-8c3d-b62c3ee9223b{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:12px}'
          }
        </style>
      </defs>
      <circle cx={830.5} cy={334.5} r={69.5} />
      <path
        className="e000f16a-d505-4d18-8c3d-b62c3ee9223b"
        d="M830.5 388v243M830.5 620S781 667 775 679s-49 66-55 144M830.5 620c12.16 17.42 99.34 95.79 111.5 209M621 293.82c13 151 209.5 146 209.5 146s-59.5 29-123.5 133"
      />
    </svg>
  )
}

export default Dummy